import React from "react";
import styles from "./Header.module.css";
import { NavLink } from "react-router-dom";

import phnIcon from "../../assets/icons/phnIcon.png";
import { useAuth } from "../../context/auth";

const Header = () => {

  const {  LogoutUser } = useAuth();
  const token = localStorage.getItem("token");
    return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <img src={phnIcon} alt="phn" />
          <p>912121131313</p>
        </div>
        <div className={styles.middle}>
        Get 50% off on selected items  &nbsp;   |   &nbsp;  Shop Now
        </div>
        {token ? ( 
          <div className={styles.right}>
            <button className={styles.logout_btn} onClick={LogoutUser}>Logout</button>
          </div>
        ) : (
          
          <div className={styles.right}>
            <NavLink to="/login">Login</NavLink> &nbsp;|&nbsp;
            <NavLink to="/signup">Sign up</NavLink>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
